import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-language',
	templateUrl: './language.component.html',
	styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {
	languageForm:any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	languageList:any;
	selectedLanguage:any;
	modalTitle:any;
	btnTitle:any;
	isActivatedDelete:boolean=false;
	isActivatedAdd:boolean=false;
	isActivatedEdit:boolean=false;
	selected_id: string;
	selected_name : string;
	searchStr:any='';
	isLanguageAvailable:boolean=true;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("Language");
		this.commonService.process();
		this.pageNo = 1;
		this.limit = 10;

		this.languageForm = new FormGroup({
			language_code: new FormControl("", Validators.compose([
				Validators.required,
			])),

			language: new FormControl("", Validators.compose([
				Validators.required,
			])),
		});

		this.getLanguageList(this.pageNo, this.limit, this.searchStr);
	}

	// Get language list
	getLanguageList = function (pageNo, limit, searchStr){
		this.commonService.process();
		this.authService.getLanguage(pageNo, limit, searchStr).subscribe(data=>{
			if(data.success) {
				this.isLanguageAvailable = true;
				this.languageList = data.language;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else{
				this.languageList = [];
				this.isLanguageAvailable = false;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

        // get current page of items
		this.pagedItems = this.languageList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if(!param) {
			this.getLanguageList(page, this.limit, this.searchStr);
		}
	}

	addLanguage = function () {
		this.resetForm();
		this.modalTitle = "Add Language";
		this.btnTitle = "Save";
		this.isActivatedAdd = true;
		this.isActivatedDelete = false;
		this.isActivatedEdit = false;
	}

	// Selected language to be update
	updateSelectedLanguage = function(language) {
		this.resetForm();
		this.modalTitle = "Update Language";
		this.btnTitle = "Update";
		this.isActivatedAdd = false;
		this.isActivatedDelete = false;
		this.isActivatedEdit = true;
		this.selectedLanguage = language;
		this.languageForm.controls['language'].setValue(language.language);
		this.languageForm.controls['language_code'].setValue(language.language_code);
		this.selected_id = language._id;
	}

	// Selected language to be delete
	deleteSelectedLanguage = function(language) {
		this.resetForm();
		this.modalTitle = "Delete Language";
		this.btnTitle = "Delete";
		this.isActivatedDelete = true;
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.selectedLanguage = language;
		this.selected_id = language._id;
		this.selected_name= language.language;
	}

	//Reset Form
	resetForm()
	{
		this.languageForm.reset();
		this.selectedLanguage = null;
	}

	// Submit ( Add language functionality)
	manageLanguage(LanguageForm)
	{	
		if(this.languageForm.valid && this.isActivatedAdd)
		{	
			this.btnTitle = "Saving..."
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageLanguage(LanguageForm,null, 'add').subscribe(data=>{
				if(data.success) {
					this.getLanguageList(1, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else if(this.languageForm.valid && this.isActivatedEdit)
		{	
			this.btnTitle = "Updating..."
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageLanguage(LanguageForm,this.selected_id, 'edit').subscribe(data=>{
				if(data.success) {
					this.getLanguageList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else if(this.isActivatedDelete)
		{	
			this.btnTitle = "Deleting...";
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.manageLanguage(null,this.selected_id, 'delete').subscribe(data=>{
				if(data.success) {
					this.getLanguageList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else{
			this.validationService.validateAllFormFields(this.languageForm);
		}
	}
	closeModel = function()
	{
		$('.close').click();
	}

	// Search language
	searchLanguage = function(){
		this.searchStr = jQuery("#search").val();
		this.getLanguageList(1, this.limit, this.searchStr);
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/language/language.component.ts